
import { DetectedLocation } from '../mappings/LocationMapping';

export const logHierarchyDecision = (detectedLocation: DetectedLocation) => {
  console.log('🏆 === HIERARCHY DECISION ===');
  switch(detectedLocation.type) {
    case 'city':
      console.log('🎯 CITY SEARCH: Will show ONLY results from this specific city');
      console.log('   - City:', detectedLocation.info.city);
      console.log('   - Region:', detectedLocation.info.region); 
      console.log('   - Country:', detectedLocation.info.country);
      break;
    case 'region':
      console.log('🎯 REGION SEARCH: Will show ALL cities within this region');
      console.log('   - Region:', detectedLocation.info.region);
      console.log('   - Country:', detectedLocation.info.country);
      break;
    case 'country':
      console.log('🎯 COUNTRY SEARCH: Will show ALL regions/cities within this country');
      console.log('   - Country:', detectedLocation.info.country);
      break;
  }
};

export const logDetectionSteps = (
  detectedLocation: DetectedLocation | null,
  priceConstraints: any,
  detectedFacilities: any
) => {
  console.log('🎯 === STEP 1: HIERARCHICAL LOCATION DETECTION ===');
  console.log('Location detection result:', detectedLocation);
  
  if (detectedLocation) {
    logHierarchyDecision(detectedLocation);
  }

  console.log('💰 === STEP 2: PRICE CONSTRAINT DETECTION ===');
  console.log('Price detection result:', priceConstraints);

  console.log('🏨 === STEP 3: FACILITIES DETECTION ===');
  console.log('Facilities detection result:', detectedFacilities);
};
